import React from "react";
import womenEmpowerment from "../../Images/OurWork/women-empowerment.png";

const WomenEmpowerment = () => {
  return (
    <>
      {/* <div>WomenEmpowerment</div>; */}
      <div>
        <img src={womenEmpowerment} />
      </div>
    </>
  );
};

export default WomenEmpowerment;
